import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';

import { Button, LoadingIndicator } from '@zendesk/forethought-elements';
import { useGetIntentsQueryWithProduct } from 'src/hooks/hooks';
import {
  getWorkflowBuilderUrl,
  openTab,
} from 'src/pages/intent-conversation-analytics/helpers';

export const AssistDeepLink = ({
  linkText,
  stepId,
  workflowId,
}: {
  linkText?: string;
  stepId: string;
  workflowId: string;
}) => {
  const { t } = useTranslation('events');
  const { palette } = useTheme();
  const { data, isLoading } = useGetIntentsQueryWithProduct(undefined, {
    productOverride: 'playbook',
  });

  if (isLoading) {
    return <LoadingIndicator color={palette.colors.black} size='large' />;
  }

  const intentId =
    data?.intents.find(intent => intent.intent_workflow_id === workflowId)
      ?.intent_definition_id || '';

  const targetURL = getWorkflowBuilderUrl({
    channel: 'playbook',
    intentDefinitionId: intentId,
    intentWorkflowId: workflowId,
    stepId,
  });

  return (
    <Button
      onClick={() => {
        openTab(targetURL);
      }}
      variant='main'
    >
      {linkText ?? t('assistDeepLink.linkText')}
    </Button>
  );
};
